import {useNavigate} from "react-router-dom";
import {IModel} from "../../../kova/slsordClient";
import React, {useEffect, useMemo, useState} from "react";
import {
    filterViewItems,
    IOptionConfig,
    SiteSpecificDiv,
} from "../vscSiteSpecific/SiteSpecific";
import {useModelOptContext} from "../../../data/modelSource";
import {Client, JSGetOptContext} from "OptConfigurator";
import {
    IConfiguratorProxy,
    IOptionChoiceAvailabilityMap, IOptionItem,
    IOptionItemAvailableChoice, IOptionItemChoice

} from "@bimaire/optionslib";
import groupBy from "@bimaire/optionslib/build/utils/groupBy";
import styled from "@emotion/styled/macro";
import {useUnreal} from "../../../unreal_api/useUnreal";
import {ThemeColors} from "../../layout/GlobalLayout";
import Checkbox from "../../common/checkbox/Checkbox";
import KovaConfigurator from "@bimaire/optionslib-kova/build/loaders/kova/kovaConfigurator";
import {CameraCard} from "../vscFindYourHome/CameraCards";
import {getItemsForTab, useModelConfig} from "../vscSiteSpecific/UseModelConfig";
import {BigScreen3D, IHouseModelSetting, useCamera} from "../../../unreal/BigScreenCommunity3D";
import {ILevelGroupSetting} from "../../visualizer/VisualizerSessionManager";
import {ViewTabs} from "../../ViewTabs";
import FurnitureSwitch from "../vscSiteSpecific/FurnitureSwitch";


export interface IPlanProps {
    models: IModel[];
    id:string;
}


const SelectionsDiv = styled.section`
  padding: 32px 16px 0px 16px;
height:100%;
  max-width: 300px;
  overflow:hidden;
  box-sizing: border-box;
  display:flex;
  flex-direction: column;
  .back {
    
    align-self: flex-start;
  }
  .optionsscroller {
    
    overflow: scroll;
  }
  h3 {
    font-family: 'Bw Nista Geometric';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 22px;
    /* identical to box height */

    text-align: center;

    /* Dark Platinum */

    color: ${ThemeColors.darkplatinum};

  }
  h4 {
    font-weight: 400; font-style: normal; font-size: 18px; line-height: 25px;

  }
`
function useModelConfigurator(model:IModel) {
    const modelContext = useModelOptContext(model.id);
    const [configurator, setConfigurator] = useState<IConfiguratorProxy|null>(null);

    const loadedConfigurator = useMemo(() => {
            if (modelContext === null) return null;
            const config = Client.loadFromJSON(JSON.parse(modelContext) as JSGetOptContext);
            (window as any).optState = config; // for easy troubleshooting
        const kovaConfigurator = new KovaConfigurator(null);
        return kovaConfigurator.getConfiguratorProxy(config) as IConfiguratorProxy;
        },
        [model.id, modelContext !== null]);
    if (modelContext === null) return { configurator: null, onSelect: () => {}};
    const configuratorToUse = configurator ?? loadedConfigurator;

    const onSelect = (opt: IOptionItemChoice) => {
        const configuratorToUse2 = configurator ?? loadedConfigurator;

        if (configuratorToUse2 === null) return;
        setConfigurator(conf => (conf ?? loadedConfigurator!).applyChoice(opt));

    }

    return { configurator: configuratorToUse, onSelect};

}

export interface IConfiguratorSelectionsProps {
    configurator: IConfiguratorProxy;
    lotId:string;
    optionsVisible: IOptionConfig[]|undefined;
    onSelect: (opt: IOptionItemChoice) => void;
}
function isOptionAvailable(availabilityMap: IOptionChoiceAvailabilityMap, choice: IOptionItemAvailableChoice) {
    const av = availabilityMap.availability.get(choice);
    if (av === undefined) return false;
    return av.isEnabled && av.isVisible;
}

const UnrealOptions: React.FC<{choices: IOptionItemChoice[], lotId:string}> = (props) => {
    const  { choices, lotId } = props;
    const unrealOpts = useUnreal(choices, lotId);
    return null;
}
function getOptionNameMap(optSel: string, values: IOptionItemAvailableChoice[]) {
    let retval: Map<IOptionItemAvailableChoice, { name: string, details?: string }> = new Map<IOptionItemAvailableChoice, {name: string; details?: string}>()
    if (optSel === "EXT_COLORS") {

        let index = 1;
        for (const vn of values) {
            if (vn.items[1].item.name.toLocaleLowerCase().includes("not selected")) {
                retval.set(vn, {name: vn.items[1].item.name});
            } else {
                retval.set(vn, {name:`Package ${index++}`, details: vn.items[1].item.name});
            }
        }
    } else if (optSel === "WH_DESIGNPKG") {
        for (const vn of values) {
            let itemName = vn.items[1].item.name;
            if (vn.items.length > 2) {
                itemName = vn.items[2].item.name;
            }

            retval.set(vn, {name: itemName});
        }
    } else {
        for (const vn of values) {
            retval.set(vn, {name: vn.items[1].item.name});
        }
    }
    return retval;

}

const ConfiguratorValuesDiv = styled.div`
  ul {
    display: flex;
    flex-direction: column;
    gap:10px;
    justify-content:center;
    padding:0;
  }
  li {
    list-style: none;
    display:block;
    > * {
      height: 38px;

    }
    background-color: white;
  }
h4 {
  /* Elevation */


  font-family: 'Bw Nista Geometric';
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 25px;
  /* identical to box height, or 139% */

  margin:0;

  /* Dark Platinum */

  color: ${ThemeColors.darkplatinum};

}
`


interface IConfiguratorValuesProps {
    selection: IOptionItem;
    values: IOptionItemAvailableChoice[];
    selectedChoice: IOptionItemChoice;
    onSelect: (opt:IOptionItemChoice) => void;
}

const ConfiguratorValues: React.FC<IConfiguratorValuesProps> = (props) => {
    const { values, selection, selectedChoice, onSelect } = props;
    const optNameMap = getOptionNameMap(selection.id, values);

    useEffect(() => {
        console.log(selectedChoice.choice.items[1].item.name);
        if (selectedChoice.choice.items[1].item.name === "Please Select" || selectedChoice.choice.items[1].item.name === "Not Selected") {
            console.log('overriding choice to ' + values[1].items[1].item.name);
            onSelect({choice: values[1], quantity: 1, price:null});
        }

    }, [selectedChoice.choice.items[1].item.name])
    let optvalname =  values[0].items[0].item.name;
    if (optvalname === "Whole House Design Upgrade Package") {
        optvalname = "Interior Design Package";
    }
    return <ConfiguratorValuesDiv>
        <h4>{ optvalname } </h4>


        <ul>
        { values.filter(val => val.items[1].item.name !== "Please Select" && val.items[1].item.name !== "Not Selected").map(val => <li title={val.items[1].item.id}>
            <Checkbox checked={selectedChoice?.choice === val}
                      onValueChanged={() => onSelect({ choice: val, quantity: 1, price: null}) }>
                { optNameMap.get(val)!.name}
            </Checkbox>
        </li>)}
        </ul>
    </ConfiguratorValuesDiv>
}
const ConfiguratorSelections: React.FC<IConfiguratorSelectionsProps> = (props) => {

    const { configurator, onSelect, lotId, optionsVisible } = props;

    const navigate = useNavigate();
    const allChoices = configurator.getAllChoices();
    const optionsVisibleNormalized = optionsVisible?.map(ov => typeof ov === "string" ? { id: ov, name: ov } : ov);


    const optionsVisibleIds = optionsVisibleNormalized?.map(ov => ov.id);

    const enabledChoices = optionsVisibleIds === undefined ? allChoices : allChoices.filter(ch => optionsVisibleIds.includes(ch.items[0].item.id));
    const avail = configurator.getOptionAvailability(enabledChoices);
    const visibleChoices = enabledChoices.filter(ch => isOptionAvailable(avail, ch));
    const activeChoices = configurator.getChoices();
    const choicesByOption = groupBy(visibleChoices, ch => ch.items[0].item.id);
    return <SelectionsDiv>

        <div className={"back"}>
            <a href='#' onClick={(ev: React.MouseEvent) => {ev.preventDefault(); navigate(-1); } } className={"back"}>
                &lt; Back</a>

        </div>
        <div className={"optionsscroller"}>
        <div className={"options"}>

        <UnrealOptions choices={activeChoices} lotId={lotId} />
        { Object.keys(choicesByOption).map(selId => <div>
            <ConfiguratorValues selection={choicesByOption[selId][0].items[0].item}
                                values={choicesByOption[selId]}
                                selectedChoice={activeChoices.find(ch => ch.choice.items[0].item.id === selId)!}
                                onSelect={onSelect}
            />
        </div>) }
        </div>
        </div>
    </SelectionsDiv>


}

export const PlanLayout = styled.div`

  display: flex;
  height:100%;
  flex-direction: column;
    .content {
      height:calc(100% - 80px);
    }
  .footer {
    background-color: white;
    display:flex;
    align-items: center;
    justify-content: center;
    height:80px;
  }
  .selections {
    overflow-y: auto;
  }
    
`
const Plan: React.FC<IPlanProps> = (props) => {

    const [viewItemIndex, setViewItemIndex] = useState<number>(0);
    const [activeViewTab, setActiveViewTab] = useState<string | null>(null);
    const [showFurniture, setShowFurniture] = useState<boolean>(false);
    const {models} = props;
    const planId = props.id;
    const model = models.find(model => model.id === planId);
    if (model === undefined) {
        throw new Error('model not found');
    }
    const modelConfig = useModelConfig(model.id ?? "");
    const levelId = modelConfig?.unrealId ?? model.id ?? "";
    const lotId = modelConfig?.lotId ?? "GenLot";


    console.log('Rendering plan');
    const {configurator, onSelect} = useModelConfigurator(model);


    const viewTabs = modelConfig?.views.map(v => v.name) ?? [];
    const activeTabToUse = activeViewTab ?? viewTabs[0] ?? "";
    const allViewItems = getItemsForTab(activeTabToUse, modelConfig);
    const viewItems = filterViewItems(allViewItems, ["plan"]);

    let selectedViewItem = viewItems[viewItemIndex];
    if (!selectedViewItem) {
        selectedViewItem = viewItems[0];
    }
    const cameraId = (selectedViewItem && selectedViewItem.type === "camera") ? "GL_" + levelId + "_" + selectedViewItem.camera : null;
    useCamera(cameraId);
    const levelGroup: ILevelGroupSetting = {
        lot: lotId,
        levelGroup: (selectedViewItem && selectedViewItem.type === "camera") ? (selectedViewItem?.levelgroup ?? "All") : "All"
    };
    if (showFurniture) {
        levelGroup.levelGroup += "_Furn";
    }
    //useParking(parkedCar);
    //useCamera(cameraId);

    if (configurator === null) {
        return <div>Loading plan...</div>;
    }
    ;



    const houseModel: IHouseModelSetting = {
        houseModel: "LV-" + levelId,
        lotId: lotId
    };
    return <PlanLayout>
        <div className={"content"}>
        <SiteSpecificDiv>
        <BigScreen3D camera={cameraId} levelGroups={[levelGroup]} lotLabels={[]} houseModels={[houseModel]}/>
        <div className={"views"}>
            <ViewTabs viewTabs={viewTabs} activeViewTab={activeTabToUse} onSetActiveViewTab={(tabName: string) => {
                setViewItemIndex(0);
                setActiveViewTab(tabName);
            }}/>
            <div className={"cameras"}>
                {viewItems.map((cam, idx) => <CameraCard key={idx} camera={cam} isActive={idx === viewItemIndex} onClick={() => setViewItemIndex(idx)}/>)}
            </div>
        </div>
        <div className={"selections"}>
            <ConfiguratorSelections configurator={configurator} optionsVisible={modelConfig?.options} onSelect={onSelect} lotId={lotId}
                                    />
        </div>
    </SiteSpecificDiv>
        </div>
        <div className={"footer"}>

            <FurnitureSwitch checked={showFurniture} onChange={() => setShowFurniture(old => !old)} />
        </div>
    </PlanLayout>
}

export default Plan;